module.exports = __webpack_public_path__ + "static/4-68afb2ffdc0e15b0f32db9690f51a1db.jpg";